module.exports = "/_next/static/images/sh-c39480d514fe1af4c7e5f62a3ac53b67.svg";